import SimpleLoader from "Components/Shared/SimpleLoader";
import { useTrunk } from "Hooks/Endpoints";
import React from "react";
import TrunkCreateForm from "./TrunkCreateForm";
import TrunkEditForm from "./TrunkEditForm";
import TrunkList from "./TrunkList";

const TrunkView = () => {
  const { trunk, createTrunk, loading } = useTrunk();
  return (
    <SimpleLoader loading={loading}>
      {!trunk && !createTrunk && <TrunkList />}
      {!trunk && createTrunk && <TrunkCreateForm />}
      {trunk && <TrunkEditForm />}
    </SimpleLoader>
  );
};

export default TrunkView;
